import "./style-LoadingIframe.css";

const LoadingIframe = ({ loading }) => {
  return (
    <div
      style={
        loading
          ? {
              animation: "none",
            }
          : {
              animation: "fade 3s ease forwards",
            }
      }
      className="loadingIframe"
    >
      <span class="loader"></span>
    </div>
  );
};

export { LoadingIframe };
